import { default as _91slug_93BzaHAB5h4MMeta } from "/app/pages/[category]/[slug].vue?macro=true";
export default [
  {
    name: "category-slug___ar",
    path: "/ar/:category()/:slug()",
    meta: _91slug_93BzaHAB5h4MMeta || {},
    component: () => import("/app/pages/[category]/[slug].vue")
  },
  {
    name: "category-slug___en",
    path: "/en/:category()/:slug()",
    meta: _91slug_93BzaHAB5h4MMeta || {},
    component: () => import("/app/pages/[category]/[slug].vue")
  }
]